/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  AnalysisReportsRequestDto
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get excel by controls ids
 */
export const requestReport = (
    id: string,
    analysisReportsRequestDto: AnalysisReportsRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<null>(
      {url: `/analysis/${id}/reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: analysisReportsRequestDto, signal
    },
      options);
    }
  


export const getRequestReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestReport>>, TError,{id: string;data: AnalysisReportsRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestReport>>, TError,{id: string;data: AnalysisReportsRequestDto}, TContext> => {

const mutationKey = ['requestReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestReport>>, {id: string;data: AnalysisReportsRequestDto}> = (props) => {
          const {id,data} = props ?? {};

          return  requestReport(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestReportMutationResult = NonNullable<Awaited<ReturnType<typeof requestReport>>>
    export type RequestReportMutationBody = AnalysisReportsRequestDto
    export type RequestReportMutationError = unknown

    /**
 * @summary Get excel by controls ids
 */
export const useRequestReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestReport>>, TError,{id: string;data: AnalysisReportsRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestReport>>,
        TError,
        {id: string;data: AnalysisReportsRequestDto},
        TContext
      > => {

      const mutationOptions = getRequestReportMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    